import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 36 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M32.0156 12.6094C32.0156 12.0375 31.7884 11.4891 31.3841 11.0847C30.9797 10.6803 30.4312 10.4531 29.8594 10.4531H15.8438L13.2562 7.00312C13.0554 6.73533 12.795 6.51797 12.4956 6.36827C12.1961 6.21856 11.866 6.14062 11.5312 6.14062H6.14062C5.56875 6.14063 5.0203 6.3678 4.61593 6.77218C4.21155 7.17655 3.98438 7.725 3.98438 8.29688V27.7031C3.98438 28.275 4.21155 28.8234 4.61593 29.2278C5.0203 29.6322 5.56875 29.8594 6.14062 29.8594H29.8594C30.4312 29.8594 30.9797 29.6322 31.3841 29.2278C31.7884 28.8234 32.0156 28.275 32.0156 27.7031V12.6094Z",
      stroke: "black",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }